<template>
  <ValidationObserver ref="observer">
    <v-row>
      <v-col>
        <VTextFieldWithSuggestion
          v-model="data.container"
          :label="$t('forms.labels.container')"
          :rules="{ required: true, min: 1, max: 200 }"
          :hideDetails="true"
          outlined
          :suggestionItems="containerSuggestions"
          data-cy="inventoryForm-container"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <VTextFieldWithSuggestion
          v-model="data.location"
          :label="$t('forms.labels.location')"
          :rules="{ required: true, min: 1, max: 200 }"
          :hideDetails="true"
          outlined
          :suggestionItems="locationSuggestions"
          data-cy="inventoryForm-location"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <VSelect
          v-model="data.unit"
          :required="true"
          :label="$t('forms.labels.uniteOfMeasures')"
          itemValue="id"
          itemText="name"
          outlined
          :items="genericVolumesArray"
        />
      </v-col>
      <v-col>
        <VTextField
          v-model="data.unitPerContainer"
          :label="$t('forms.labels.uniteContainer')"
          :rules="{ required: true, min: 1, max: 200 }"
          type="number"
          outlined
          data-cy="inventoryForm-unitMeasure"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <VTextField
          v-model="data.quantityMin"
          :label="$t('forms.labels.quantityMin')"
          :rules="{ required: true, decimal: 3, min_value: 1, lEqual: [data.locationCapacity] }"
          outlined
          data-cy="inventoryForm-quantityMin"
        />
      </v-col>
      <v-col>
        <VTextField
          v-model="data.locationCapacity"
          :label="$t('forms.labels.LocationCapacity')"
          :rules="{ required: true, decimal: 3, min_value: 1, gEqual: [data.quantityMin] }"
          outlined
          data-cy="inventoryForm-locationCapacity"
        />
      </v-col>
    </v-row>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import validationProviderHelperMixin from '@/components/shared/widgets/forms/validationHelper/validationProviderHelperMixin';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { genericVolumes } from '@/aquassist-shared/constants/volumes';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VTextFieldWithSuggestion from '@/components/shared/widgets/forms/VuetifyInputs/VTextFieldWithSuggestion.vue';


export default {
    components: {
        ValidationObserver,
        VTextField,
        VSelect,
        VTextFieldWithSuggestion,
    },
    mixins: [
        validationProviderHelperMixin,
    ],
    props: {
        inventory: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                container: null,
                location: '',
                quantityMin: null,
                LocationCapacity: null,
                unit: null,
                expiration: null,
                quantity: null,
            },
            locationSuggestions: [],
            containerSuggestions: [],
        };
    },
    computed: {
        ...mapGetters([
            'site',
        ]),
        genericVolumesArray() {
            const productLocationUnits = genericVolumes.filter(p => p.tag.includes('productLocation'));
            return productLocationUnits.map(p => ({
                name: this.$t(`devices.productUnitMeasure.${p.name.toLowerCase()}`),
                id: p.name,
            }));
        },
    },
    watch: {
        data: {
            handler() {
                this.$emit('sendData', this.data);
            },
            deep: true,
        },
    },
    async created() {
        await this.dataPrep();
        if (this.isEdition) {
            this.data = this.inventory;
        }
    },
    methods: {
        async dataPrep() {
            const { data } = await this.$rq.getSiteInventoryProducts({ siteId: this.site.id });

            this.locationSuggestions = data.productInventories.map(inventory => ({ id: inventory.id, label: inventory.location }));
            this.containerSuggestions = data.productInventories.map(inventory => ({ id: inventory.id, label: inventory.container }));
        },
    },

};
</script>
